'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');
var pbizServer = (typeof window !== "undefined" ? window.pbizServer : typeof global !== "undefined" ? global.pbizServer : null);

var appDom = require('../app-dom');

var dom;
var originalBtnText;

var setupDom = function() {

	dom = {};
	dom.blogDetail = $('.blog-detail');
	dom.commentForm = dom.blogDetail.find('.blog-detail__comment-form');
	dom.submitCommentBtn = dom.blogDetail.find('.blog-detail__comment-form-btn');
	dom.commentDisplay = dom.blogDetail.find('#commentDisplay');

};

var addEventHandlers = function() {

	dom.submitCommentBtn.on('click', onSubmitCommentBtnClicked);

};

var onSubmitCommentBtnClicked = function(e) {

	e.preventDefault();

	originalBtnText = $(this).text();

	dom.submitCommentBtn.text(pbizServer.content['Generic.Loading']);

	$.ajax({
		url: dom.commentForm.attr('action'),
		method: 'POST',
		data: dom.commentForm.serialize(),
		dataType: 'JSON'
	}).done(onSubmitCommentBtnClickedDone);

};

var onSubmitCommentBtnClickedDone = function(response) {

	console.log(response);

	var $target = $('[name="' + response.target + '"]');

	if (response.status.code) {

		if (response.status.detail === 'GENERIC_ERROR') {

			var $target = dom.submitCommentBtn;

			notify.show({
				msg: response.status.msg,
				type: 'info',
				target: $target,
				closeOnClick: true,
				container: dom.commentForm
			});

		} else {

			dom.commentDisplay.html(response.markup);
			
		}
		
		dom.commentForm[0].reset();

	} else {

		$target.focus();

		notify.show({
			msg: response.status.msg,
			target: $target,
			closeOnClick: true,
			container: dom.commentForm
		});

	}

	dom.submitCommentBtn.text(originalBtnText);

};

var init = function() {

	console.log('comment form is runnning!')
	console.log(appDom.document.find('.blog-detail__comment-form'))

	if (appDom.document.find('.blog-detail__comment-form')) {

		setupDom();

		addEventHandlers();

	}

};

module.exports = {
	init: init
};